import { Component, computed, inject, viewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ContractPartnerType } from '../../../meterpoint-change-request.types';
import { SignalState } from '@shared-ikp/service/signal-state-service/signal-state.service';
import { PrivatePersonFormComponent } from '../private-person-form/private-person-form.component';
import { OrganizationFormComponent } from '../organization-form/organization-form.component';
import { TranslatePipe } from '@ngx-translate/core';
import { MeterPointChangeSignalState } from '../../../meterpoint-change-request.types';

@Component({
  selector: 'ikp-contact-information',
  templateUrl: './contact-information.component.html',
  standalone: true,
  imports: [ReactiveFormsModule, PrivatePersonFormComponent, OrganizationFormComponent, TranslatePipe],
})
export class ContactInformationComponent {
  protected readonly wizardStore: MeterPointChangeSignalState = inject(SignalState);
  protected readonly contractPartnerType = computed(() => this.wizardStore.state().newContractPartner.formData?.partnerType);
  protected readonly ContractPartnerType = ContractPartnerType;

  private contactInformationFormPrivate = viewChild(PrivatePersonFormComponent);
  private contactInformationFormOrganization = viewChild(OrganizationFormComponent);

  public get validContactInformationForm(): boolean {
    switch (this.contractPartnerType()) {
      case ContractPartnerType.PRIVATE:
        return this.contactInformationFormPrivate().validForSubmission;
      case ContractPartnerType.COMPANY:
        return this.contactInformationFormOrganization().validForSubmission;
      default:
        return false;
    }
  }
}
